export default __webpack_public_path__ + "static/media/faq_icon.05e1d6ee.svg";